export default __webpack_public_path__ + "images/4aa3ab0f92d3f2e569568bf1bcb92746.svg";